import AdminEleven from "@/layouts/AdminEleven.vue";

export const privateRoutes = [
  // ---- Dashboard ---- //
  {
    path: "/home",
    component: AdminEleven,
    props: {
      withSearchInput: false,
    },
    children: [
      {
        name: "home",
        path: "",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/Home.vue"),
        meta: { title: "Home", requiresAuth: true },
      },
      {
        name: "resume",
        path: "evento/:id",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/resume/ResumeEvent.vue"
          ),
        meta: { title: "Resumo Evento", requiresAuth: true },
      },
      {
        name: "dashboard-produtor",
        path: "/dashboard-produtor",
        component: () => import("@/views/DashboardProducer.vue"),
        meta: { title: "Dashboard Produtor", requiresAuth: true },
      },
    ],
  },

  // ---- Termos ---- //
  {
    path: "/termos",
    component: AdminEleven,
    props: {
      withSearchInput: false,
    },
    children: [
      {
        name: "termos",
        path: "",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/termos/Termos.vue"),
        meta: { title: "Termos", requiresAuth: true },
      },
    ],
  },
  {
    path: "/termos-afiliados",
    component: AdminEleven,
    props: {
      withSearchInput: false,
    },
    children: [
      {
        name: "termos-afiliados",
        path: "",
        component: () => import("@/views/termos/TermsAffiliates.vue"),
        meta: { title: "Termos", requiresAuth: true },
      },
    ],
  },
  {
    path: "/ranking-afiliados",
    component: AdminEleven,
    props: {
      withSearchInput: false,
    },
    children: [
      {
        name: "ranking-afiliados",
        path: "",
        component: () => import("@/views/Ranking.vue"),
        meta: { title: "Termos", requiresAuth: true },
      },
    ],
  },
];
